{
  "Domain": "Domain:",
  "EmailServerConnectivity": "E-Mail-Server-Konnektivität",
  "ServerIpAddress": "Server IP Adresse:",
  "TcpPort": "TCP-Port:",
  "CommunicationActive": "Kommunikation aktiv:",
  "FromAddressEmail": "Absenderadresse (E-Mail):",
  "FromAddressName": "Absenderadresse (Name):",
  "CompanyName": "Name der Firma:",
  "UseAuthentication": "Authentifizierung verwenden:",
  "AuthenticationSettings": "Authentifizierungseinstellungen",
  "DomainProfile_ButtonHelpLabel": "Hilfe?",
  "DomainProfile_ButtonSubmitLabel": "OK",
  "DomainProfile_ButtonCancelLabel": "Absagen",
  "DomainProfile_PromptMessage": "Möchten Sie dieses Fenster wirklich schließen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
  "DomainProfile_PromptConfirm": "Ja",
  "DomainProfile_PromptCancel": "Absagen",
  "DomainProfile_Username": "Nutzername:",
  "DomainProfile_Password": "Passwort:",
  "DomainProfile_PasswordPlaceholder": "••••••",
  "NAME": "DomainProfile",
  "CustomDownloadLinks": "Benutzerdefinierte Download-Links",
  "MSTeamsAppDownloadLinkURLName": "Download-URL für die MS Teams-App:",
  "CXIClientDownloadLinkWindowsUrlName": "CXI-Client (Windows) URL:",
  "CXIClientDownloadLinkMacUrlName": "CXI-Client (Mac) URL:",
  "SearchAndCallDownloadLinkURLName": "URL suchen und aufrufen:",
  "AccessCodes": "Zugangscodes",
  "CXIAccessCode": "CXI-Zugangscode:"
}